import { useContext, useMemo } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { PermissionsContext } from "context/AppProvider/PermissionsContext";
import { PERMISSIONS } from "constants/portal";
import { permissionChecker } from "helpers/common";
import { useSelector } from "react-redux";

const useAllowScheduleActions = (item) => {
  const { user } = useAuth0();
  const { userPermissions } = useContext(PermissionsContext);
  const { sharedSchedules } = useSelector((store) => store?.designer?.calendar);

  const permissions = useMemo(() => {
    if (!user || !item) {
      return {
        allowEdit: false,
        allowDelete: false,
        allowPause: false,
        allowShare: false,
        allowUnshare: false,
        isOwner: false
      };
    }

    const isOwner = item?.created_by_id === user?.cxfUserId;
    const sharedSchedule = sharedSchedules?.find(
      (schedule) => schedule.schedule_id === item.id && schedule.shared_user_id === user.cxfUserId
    );

    const isEditor = sharedSchedule?.access_type === "editor";

    const allowEdit =
      permissionChecker(userPermissions, PERMISSIONS.EDIT_ANY_SCHEDULES) ||
      ((isOwner || isEditor) && permissionChecker(userPermissions, PERMISSIONS.EDIT_SCHEDULES));
    const allowDelete =
      permissionChecker(userPermissions, PERMISSIONS.DELETE_ANY_SCHEDULES) ||
      (isOwner && permissionChecker(userPermissions, PERMISSIONS.DELETE_SCHEDULES));
    const allowPause = isOwner && permissionChecker(userPermissions, PERMISSIONS.PAUSE_SCHEDULES);
    const allowShare =
      permissionChecker(userPermissions, PERMISSIONS.SHARE_ANY_SCHEDULES) || isOwner || isEditor;

    return {
      allowEdit,
      allowDelete,
      allowPause,
      allowShare,
      allowUnshare: allowShare,
      isOwner,
      canOpenMenu: allowEdit || allowDelete || allowPause || allowShare
    };
  }, [user, item, userPermissions, sharedSchedules]);

  return permissions;
};

export default useAllowScheduleActions;
